export default __webpack_public_path__ + "static/media/freelancer-logo.60d7911e.svg";